import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function ReceivedEmail(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "ReceivedEmail", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M42.3846 9H24.6154C23.7232 9 23 9.70355 23 10.5714v29.8572C23 41.2964 23.7232 42 24.6154 42h17.7692C43.2768 42 44 41.2964 44 40.4286V10.5714C44 9.70355 43.2768 9 42.3846 9Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M36.08 12h-5.16c-.334.0002-.6585-.1112-.922-.3163-.2636-.2051-.4512-.4924-.533-.8162L29 9h9l-.465 1.8675c-.0818.3238-.2694.6111-.533.8162-.2635.2051-.588.3165-.922.3163Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m38 21.3334-1.6429 8.3333c0 .884-.3462 1.7319-.9624 2.357-.6162.6251-1.4519.9763-2.3233.9763H18.2857c-.8714 0-1.7071-.3512-2.3233-.9763-.6162-.6251-.9624-1.473-.9624-2.357l1.6429-8.3333c-.0025-.4714.0935-.938.2819-1.3689.1883-.4309.4646-.8165.8106-1.1311.6053-.5417 1.386-.8383 2.1932-.8333h14.7856c.8072-.005 1.5879.2916 2.1933.8333.3459.3146.6222.7002.8105 1.1311.1884.4309.2845.8975.282 1.3689Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m37 18.8497-10.135 6.7975c-.2846.2288-.6338.3528-.9931.3528-.3593 0-.7085-.124-.9932-.3528L18 18.8497c.5999-.5522 1.3736-.8547 2.1735-.8496h14.653c.7999-.0051 1.5736.2974 2.1735.8496Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M14.2143 22.6h-3.1429c-.2084 0-.4082-.0843-.5556-.2343-.1473-.15-.2301-.3535-.2301-.5657s.0828-.4157.2301-.5657c.1474-.15.3472-.2343.5556-.2343h3.1429c.2084 0 .4082.0843.5556.2343.1473.15.2301.3535.2301.5657s-.0828.4157-.2301.5657c-.1474.15-.3472.2343-.5556.2343Zm-1.5714 3.2H7.92857c-.20838 0-.40823-.0843-.55558-.2343-.14735-.15-.23013-.3535-.23013-.5657s.08278-.4157.23013-.5657c.14735-.15.3472-.2343.55558-.2343h4.71433c.2083 0 .4082.0843.5555.2343.1474.15.2302.3535.2302.5657s-.0828.4157-.2302.5657c-.1473.15-.3472.2343-.5555.2343ZM11.0714 29H4.78571c-.20838 0-.40823-.0843-.55558-.2343C4.08278 28.6157 4 28.4122 4 28.2s.08278-.4157.23013-.5657c.14735-.15.3472-.2343.55558-.2343h6.28569c.2084 0 .4083.0843.5556.2343.1474.15.2301.3535.2301.5657s-.0827.4157-.2301.5657c-.1473.15-.3472.2343-.5556.2343Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
ReceivedEmail.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "ReceivedEmail"
};
validateTidalLicense();
export {
  ReceivedEmail
};
//# sourceMappingURL=ReceivedEmail.js.map
